const cfg =
  typeof window !== 'undefined' && window.__LANDING_CONFIG__
    ? window.__LANDING_CONFIG__
    : { registerUrl: '#', loginUrl: '#', blogUrl: '#', stocksWebOrigin: '' };

function hydrateAfterFirstPaint() {
  void import('./hydrateLandingApp.jsx').then(({ hydrateLandingApp }) => {
    hydrateLandingApp(cfg);
  });
}

if ('requestAnimationFrame' in window) {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(hydrateAfterFirstPaint);
  });
} else {
  window.setTimeout(hydrateAfterFirstPaint, 0);
}
